import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Button } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.js';
import { FORM_TYPES } from '../../../types/paramsConfig.js';
import { navigateToThunk } from '../../../redux/core/navigation/navigationSlice.js';
import { isInTwoStepWrapper } from '../../../tracking/constants.js';
import { useTrack } from '../../../tracking/common/hooks/useTrack.js';
import { setActiveView, activeWrapperSelector, } from '../../../redux/core/wrapperContext/wrapperContextSlice.js';
export const ForgotPasswordLink = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const activeWrapper = useAppSelector(activeWrapperSelector);
    const { trackBtnClick } = useTrack(isInTwoStepWrapper(activeWrapper) ? 'twoStep' : 'standard');
    const showResetPasswordModal = () => {
        trackBtnClick({ uniqueName: 'forgotPassword' });
        if (isInTwoStepWrapper(activeWrapper)) {
            // TODO: replace that with navigateTo
            dispatch(setActiveView(FORM_TYPES.TWO_STEP_RESET_PASSWORD));
        }
        else {
            dispatch(navigateToThunk(FORM_TYPES.RESET_PASSWORD));
        }
    };
    return (_jsx(Button, { "data-testid": "forgot-password-link", a11yLabel: "butn", variant: "link", size: ['small'], onClick: showResetPasswordModal, children: t('loginregistration.login.forgotPassword') }));
};
//# sourceMappingURL=ForgotPasswordLink.js.map